export default function scrollTo(top, smooth) {
  if (typeof window === 'undefined') {
    return false;
  }
  window.document.documentElement.scrollTo({
    top: top,
    behavior: smooth ? 'smooth' : 'auto'
  });
}
